export default __webpack_public_path__ + "static/media/004-financial-report.97efa2c4.png";